import { createRouter, createWebHistory } from "vue-router"
import type { RouteRecordRaw } from "vue-router"
import extendsRoutes from './extendsRoutes'

export const constantRoutes: RouteRecordRaw[] = [
    ...extendsRoutes,
    {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/index"),
        meta: {
            KeepAlive: true,
            title: "登录"
        }
    },
    {
        path: "/",
        name: "Home",
        component: () => import("@/views/home/index"),
        meta: {
            KeepAlive: true,
            title: "",
        }
    },
    {
        path: "/404",
        name: "NotFound",
        component: () => import("@/views/error-page/404"),
        meta: {
            KeepAlive: true,
            title: "404",
        },
    },
]

// 创建路由
const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_ROUTER_BASE),
    routes: constantRoutes as RouteRecordRaw[]
})

export default router
